import axiosClient from './axiosClient'

const PATH = '/price-change-histories'

export const priceChangeHistoryApi = {
  getPriceChangeHistory: (tankId: number) =>
    axiosClient.get(PATH, {
      params: {
        tankId,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
